// src/app/app.module.ts
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { NgSelectModule } from '@ng-select/ng-select';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// Modals
import { SavelocationPageModule } from './modals/savelocation/savelocation.module';
import { AddReviewPageModule } from './modals/add-review/add-review.module';
import { PaymentModalPageModule } from './modals/payment-modal/payment-modal.module';
import { CancelBookingPageModule } from './modals/cancel-booking/cancel-booking.module';
import { SocialiconPageModule } from './modals/socialicon/socialicon.module';
import { SortbyPageModule } from './modals/sortby/sortby.module';
import { CouponPageModule } from './modals/coupon/coupon.module';

// Services
import { ApiInterceptor } from './services/interceptors/api.interceptor';
import { LoaderInterceptor } from './services/interceptors/loader.interceptor'; // ✅ Added
import { AuthGuardService } from './services/auth-guard.service';
import { AuthenticationService } from './services/authentication.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';

import { SideMenuComponent } from './pages/side-menu/side-menu.component';
import { LoginRequiredSheetComponent } from './login-required-sheet/login-required-sheet.component';

// AoT-safe factory
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SideMenuComponent,
    LoginRequiredSheetComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,

    HttpClientModule,
    IonicStorageModule.forRoot(),
    NgSelectModule,

    // Modals
    SavelocationPageModule,
    AddReviewPageModule,
    PaymentModalPageModule,
    CancelBookingPageModule,
    SocialiconPageModule,
    SortbyPageModule,
    CouponPageModule,

    GooglePlaceModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },

    // ✅ Loader FIRST
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },

    // ✅ ApiInterceptor SECOND
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },

    AuthGuardService,
    AuthenticationService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }